document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');

  if (toggle && mobileNav) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      mobileNav.hidden = open;
    });
  }

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const select = root.querySelector('[data-variant-select]');
    const price = root.querySelector('[data-product-price]');
    const button = root.querySelector('[data-add-button]');
    const buttonText = root.querySelector('[data-add-button-text]');

    if (!select) return;

    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const available = option.dataset.available === 'true';
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (button) button.disabled = !available;
      if (buttonText) buttonText.textContent = available ? 'Add to cart' : 'Sold out';
    });
  });
});
